<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M15.999 2.933c4.267 0 4.8 0 6.4 0.134 4.399 0.134 6.4 2.267 6.533 6.534 0.134 1.733 0.134 2.127 0.134 6.4s0 4.8-0.134 6.4c-0.134 4.267-2.267 6.4-6.533 6.534-1.733 0.134-2.133 0.134-6.4 0.134s-4.8 0-6.4-0.134c-4.399-0.134-6.4-2.267-6.533-6.534-0.134-1.733-0.134-2.127-0.134-6.4s0-4.8 0.134-6.4c0.134-4.267 2.267-6.4 6.533-6.534 1.6-0.134 2.133-0.134 6.4-0.134zM15.999 0c-4.401 0-4.934 0-6.534 0.134-5.867 0.267-9.066 3.467-9.333 9.333-0.133 1.733-0.133 2.266-0.133 6.533 0 4.401 0 4.934 0.134 6.534 0.267 5.867 3.467 9.066 9.333 9.333 1.733 0.134 2.267 0.134 6.534 0.134 4.401 0 4.934 0 6.534-0.134 5.867-0.267 9.066-3.467 9.333-9.333 0.134-1.733 0.134-2.267 0.134-6.534 0-4.401 0-4.934-0.134-6.534-0.267-5.867-3.467-9.066-9.333-9.333-1.602-0.133-2.14-0.133-6.535-0.133zM15.999 7.734c-4.566 0-8.267 3.701-8.267 8.267s3.701 8.267 8.267 8.267c4.566 0 8.267-3.701 8.267-8.267v0c-0.023-4.556-3.711-8.243-8.265-8.267h-0.002zM15.999 21.333c-2.945 0-5.333-2.388-5.333-5.333s2.388-5.333 5.333-5.333c2.945 0 5.333 2.388 5.333 5.333v0c-0.009 2.941-2.391 5.323-5.332 5.333h-0.001zM24.533 5.6c-1.031 0-1.867 0.836-1.867 1.867s0.836 1.867 1.867 1.867c1.031 0 1.867-0.836 1.867-1.867v0c0-0.013 0.001-0.029 0.001-0.044 0-1.007-0.816-1.823-1.823-1.823-0.016 0-0.031 0-0.047 0.001l0.002-0z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
